import { ILevels, IPricing, ISkillPricing } from '@wot/typings';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import pricingApi, { PricingReqBody } from '../../../api/pricing';
import { Button } from '@wot/components';

export function SkillPricing() {
  const [pricing, setPricing] = useState<IPricing<ISkillPricing>>({
    _id: '',
    type: 'skill',
    pricing: {
      levels: {
        beginner: {
          standard: 0,
          premium: 0
        },
        intermediate: {
          standard: 0,
          premium: 0
        },
        advance: {
          premium: 0,
          standard: 0
        }
      }
    },
    createdAt: '',
    updatedAt: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (type: ILevels, newValues: any) => {
    if (pricing) {
      setPricing({
        ...pricing,
        pricing: {
          ...pricing.pricing,
          levels: {
            ...pricing.pricing.levels,
            [type]: {
              ...pricing.pricing.levels[type],
              ...newValues
            }
          }
        }
      });
    }
  };

  const savePricing = () => {
    let data: PricingReqBody = {
      pricing: pricing.pricing,
      type: 'skill'
    };
    if (pricing._id) {
      setLoading(true);
      pricingApi
        .updatePricing(pricing)
        .then(() => {
          setLoading(false);
          toast.success('Skills Pricing updated successfully!');
        })
        .catch(() => {
          setLoading(false);
          toast.success('Something went wrong.');
        });
    } else {
      setLoading(true);
      pricingApi
        .savePricing(data)
        .then((data) => {
          if (data) {
            setPricing(data);
            toast.success('Skills Pricing added successfully!');
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          toast.success('Something went wrong.');
        });
    }
  };

  useEffect(() => {
    pricingApi.getPricing('skill').then((data) => {
      if (data && data._id) {
        setPricing(data);
      }
    });
  }, []);

  return (
    <div className="w-full flex flex-col ">
      <div className="flex flex-col py-5 px-2">
        <table className="min-w-full table-auto">
          <thead className="bg-neutralBlue2">
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase mx-4">Level</h1>
            </th>
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase">Standard</h1>
            </th>
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase">Premium</h1>
            </th>
          </thead>
          <tbody>
            {pricing &&
              Object.keys(pricing.pricing.levels).map((item, index) => (
                <tr key={index}>
                  {/* @ts-ignore */}
                  <Item
                    level={item} //@ts-ignore
                    standard={pricing.pricing.levels[item].standard} //@ts-ignore
                    premium={pricing.pricing.levels[item].premium}
                    handleChange={handleChange}
                  />
                </tr>
              ))}
          </tbody>
        </table>

        <div className="w-full bg-white py-10">
          <div className="max-w-[164px] w-full mx-auto flex gap-4 items-center justify-center">
            {/* <Button block type="s-outlined" text={'Cancel'} onClick={() => { }} /> */}
            <Button block loading={loading} text={'Save'} onClick={() => savePricing()} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function Item({
  level,
  standard,
  premium,
  handleChange
}: {
  level: string;
  standard: number;
  premium: number;
  handleChange: any;
}) {
  return (
    <>
      <td className="text-left py-2">
        <div className="w-full max-w-[128px] px-4 py-2 border rounded-md">
          <h1 className="text-sm capitalize">{level}</h1>
        </div>
      </td>
      <td className="text-left py-2">
        <div className="w-full  max-w-[128px] px-4 py-2 border rounded-md flex gap-2">
          <h3 className="text-sm">INR</h3>
          <input
            type="number"
            defaultValue={standard}
            value={standard}
            onChange={(e) => handleChange(level, { standard: e.target.value })}
            className="w-full text-sm border-none outline-none bg-none"
          />
        </div>
      </td>
      <td className="text-left py-2">
        <div className="w-full max-w-[128px] px-4 py-2 border rounded-md flex gap-2">
          <h3 className="text-sm">INR</h3>
          <input
            type="number"
            defaultValue={premium}
            value={premium}
            onChange={(e) => handleChange(level, { premium: e.target.value })}
            className="w-full  text-sm border-none outline-none bg-none"
          />
        </div>
      </td>
    </>
  );
}
